import { Link } from 'react-router-dom'

const NotFoundPage = () => {
	return (
		<section
			className="flex items-center h-screen dark:bg-ci1 dark:text-gray-100"
			style={{
				backgroundImage: `url(${process.env.PUBLIC_URL}/images/logos/logo-opacity.png)`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: '50% 50%',
				backgroundSize: 'contain'
			}}
		>
			<div className="flex flex-col items-center justify-center mx-auto">
				<div className="text-center">
					<h2 className="mb-8 font-extrabold text-9xl dark:text-ci5">
						<span className="sr-only">Error</span>404
					</h2>
					<p className="text-2xl font-semibold md:text-3xl">
						Sorry, we couldn't find this page.
					</p>
					<p className="mt-4 mb-8 dark:text-gray-400">
						But don't worry, you can find plenty of other things on our homepage.
					</p>
					<Link
						to="/home"
						className="px-8 py-3 font-semibold rounded dark:bg-ci2 hover:bg-ci4 hover:text-white"
					>
						Back to homepage
					</Link>
				</div>
			</div>
		</section>
	)
}

export default NotFoundPage
